import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import LeadingWithPurpose from '../Components/sustainability/LeadingWithPurpose'
import OurCommitments from '../Components/sustainability/OurCommitments'
import OurVisionSection from '../Components/sustainability/OurVisionSection'
import LeadershipCommitment from '../Components/sustainability/LeadershipCommitment'
import LeadingTheWaySection from '../Components/sustainability/LeadingTheWaySection'
import ResourceCenterSection from '../Components/sustainability/ResourceCenterSection'
import SustainabilityFramework from '../Components/sustainability/SustainabilityFramework'
import MakingHeadlines from '../Components/sustainability/MakingHeadlines'
import { Helmet } from "react-helmet-async";

function Sustainability() {
    return (
        <div>
            <Helmet>
    <title>
        Sustainability | Responsible Innovation & Sustainable Growth | Mobikode
    </title>

    <meta
        name="description"
        content="Discover Mobikode's sustainability approach focused on responsible innovation, meaningful commitments, leadership, resource efficiency, and building a sustainable future."
    />

    <meta
        name="keywords"
        content="Mobikode Sustainability, Sustainability, Sustainable Technology, Sustainable Business, Responsible Innovation, Corporate Sustainability, Sustainability Initiatives, Sustainable Growth, Environmental Responsibility, ESG, Sustainability Framework, Sustainable Future, Mobikode ESG"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/sustainability"
    />

    <meta
        property="og:title"
        content="Sustainability | Responsible Innovation & Sustainable Growth | Mobikode"
    />

    <meta
        property="og:description"
        content="Explore Mobikode's commitment to responsible innovation, sustainable growth, leadership, resource efficiency, and creating a better future."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/sustainability"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/sustainability/bg1.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Sustainability | Responsible Innovation & Sustainable Growth | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Learn how Mobikode approaches sustainability through responsible innovation, meaningful commitments, sustainable practices, and long-term impact."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/sustainability/bg1.png"
    />
</Helmet>
            <WhoHero
                title="Sustainability"
                text="Driving smart connections and experiences for a sustainable tomorrow."
                imgData="/assets/sustainability/bg1.png"
            />
            <LeadingWithPurpose />
            <OurCommitments />
            <OurVisionSection />
            <LeadershipCommitment />
            <LeadingTheWaySection />
            <ResourceCenterSection />
            <SustainabilityFramework />
            <MakingHeadlines />
        </div>
    )
}

export default Sustainability
